import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initSwiper(element) {
  const swiper = new Swiper(element, {
    modules: [Navigation],
    spaceBetween: 12,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      768: {
        spaceBetween: 20,
      },
      1440: {
        spaceBetween: 32,
      },
    },
  });

  swiper.on('progress', (swiper, progress) => {
    if (progress <= 0) {
      element.classList.add('swiper--is-at-beginning');
    } else {
      element.classList.remove('swiper--is-at-beginning');
    }

    if (progress >= 1) {
      element.classList.add('swiper--is-at-end');
    } else {
      element.classList.remove('swiper--is-at-end');
    }
  });
}

export function productShowcase() {
  const swiperElements = document.querySelectorAll('.product-showcase .swiper');
  swiperElements.forEach((element) => initSwiper(element));
}
